import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { topicsApi } from "../../services/api/topicsApi";
import { useUserContext } from "../../context/UserContext";
import FeedSidebar from "./FeedSidebar";
import { FaFire, FaArrowUp, FaHashtag } from "react-icons/fa";
import "./TrendingTopicsPage.css";

const TrendingTopicsPage = () => {
  const { user } = useUserContext();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTrendingTopics();
  }, []);

  const loadTrendingTopics = async () => {
    try {
      setLoading(true);
      const response = await topicsApi.getTrendingTopics(50);
      setTopics(response.data.topics || response.data || []);
    } catch (error) {
      // Silent fail
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="trending-topics-page">
        <div className="ttp-container">
          <div className="ttp-auth-required">
            <h2>Please log in to view trending topics</h2>
            <Link to="/" className="ttp-login-btn">
              Go to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="trending-topics-page">
      <div className="ttp-layout">
      <div className="ttp-main">
        <div className="ttp-header">
          <h1>
            <FaFire className="ttp-fire-icon" /> Trending Topics
          </h1>
          <p>Discover what the research community is talking about</p>
        </div>

        <div className="ttp-content">
          {loading ? (
            <div className="ttp-loading">
              {[...Array(10)].map((_, i) => (
                <div key={i} className="ttp-skeleton-item" />
              ))}
            </div>
          ) : topics.length === 0 ? (
            <div className="ttp-empty">
              <FaHashtag className="ttp-empty-icon" />
              <h3>No trending topics yet</h3>
              <p>Be the first to start a conversation!</p>
            </div>
          ) : (
            <div className="ttp-topics-grid">
              {topics.map((topic, index) => (
                <Link
                  key={topic.tag || topic._id || index}
                  to={`/topics/${encodeURIComponent(topic.tag)}`}
                  className="ttp-topic-card"
                >
                  <div className="ttp-topic-rank">#{index + 1}</div>
                  <div className="ttp-topic-info">
                    <h3 className="ttp-topic-name">#{topic.tag}</h3>
                    <p className="ttp-topic-count">
                      {topic.count?.toLocaleString() || 0} posts
                    </p>
                  </div>
                  {topic.growthRate > 0 && (
                    <div className="ttp-topic-growth">
                      <FaArrowUp />
                      <span>{topic.growthRate}%</span>
                    </div>
                  )}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>

      <FeedSidebar />
      </div>
    </div>
  );
};

export default TrendingTopicsPage;
